import React from 'react';
import { BENEFITS } from './summerCampContent';
export function SummerCampBenefits() {
  return <section className="py-24 bg-off-white" data-id="element-3127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3128">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3129">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3130">
            A Summer Camp That Keeps Kids Active, Engaged & Growing
          </h2>
          <p className="text-xl text-gray-warm" data-id="element-3131">
            More than just childcare. A structured experience that builds real
            skills.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3132">
          {BENEFITS.map((benefit, idx) => <div key={idx} className="bg-paper p-8 rounded-2xl border border-subtle-gray hover:border-storm-red/40 hover:shadow-lg transition-all" data-id="element-3133">
              <div className="w-14 h-14 bg-storm-red/10 rounded-xl flex items-center justify-center mb-6 text-storm-red transform -skew-x-6" data-id="element-3134">
                <benefit.icon className="w-7 h-7 transform skew-x-6" data-id="element-3135" />
              </div>
              <h3 className="text-2xl mb-3 text-ink" data-id="element-3136">{benefit.title}</h3>
              <p className="text-gray-warm leading-relaxed" data-id="element-3137">{benefit.copy}</p>
            </div>)}
        </div>
      </div>
    </section>;
}